module.exports = __webpack_public_path__ + "img/no-coupon.d7719bc5.svg";